var React = require( 'react' );
var createReactClass = require('create-react-class');
var ReactRedux = require("react-redux");
var PropTypes = require('prop-types');
var LoginModal = require('./loginModal.jsx');
var RegisterModal = require('./registerModal.jsx');
var PromisModal = require('./promisModal.jsx');
var SponsoredModal = require('./sponsoredModal.jsx');
var SpecialistModal = require('./specialistModal.jsx');
var BeforeSendHpiModal = require('./beforeSendHpiModal.jsx');
var TutorialTourModal = require('./tutorialTourModal.jsx');
var InterestedInClinicalTrialsModal = require('./interestedInClinicalTrialsModal.jsx');
var InterestedSuccessModal = require('./interestedSuccessModal.jsx');
var CollectZipCodeModal = require('./collectZipCodeModal.jsx');

var MODAL_COMPONENTS = {
  'MODAL_TYPE_LOGIN': LoginModal,
  'MODAL_TYPE_REGISTER': RegisterModal,
  'MODAL_TYPE_PROMIS': PromisModal,
  'MODAL_TYPE_SPONSORED': SponsoredModal,
  'MODAL_TYPE_SPECIALIST': SpecialistModal,
  'MODAL_TYPE_BEFORE_SEND_HPI': BeforeSendHpiModal,
  'MODAL_TYPE_TUTORIAL_TOUR': TutorialTourModal,
  'MODAL_TYPE_INTERESTED_IN_CLINICAL_TRIALS': InterestedInClinicalTrialsModal,
  'MODAL_TYPE_INTERESTED_SUCCESS': InterestedSuccessModal,
  'MODAL_TYPE_COLLECT_ZIP_CODE_MODAL': CollectZipCodeModal
}

var ModalContainer = createReactClass({

  render: function(){
    if(!this.props.modal.type) {
      return null;
    }
    var ModalComponent = MODAL_COMPONENTS[this.props.modal.type];

    return <ModalComponent {...this.props} />;
  }
});

ModalContainer.propTypes = {
  modal: PropTypes.object
};

var mapStateToProps = function(state){
    return {
      modal: state.modal
    };
}

module.exports = ReactRedux.connect(mapStateToProps)(ModalContainer);



// WEBPACK FOOTER //
// ./src/common/routes/components/modals/modalContainer.jsx